import(/* webpackMode: "eager", webpackExports: ["PageResumeWorkshop"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/events/resume-workshop/__page__/PageResumeWorkshop.tsx");
